import styled, { css } from 'styled-components'

import {
    FlexCentered,
    hideWhenNoChildren,
} from 'components/common/genericStyles'
import Tooltip2 from 'components/common/Tooltip2.0'
import { artefactColors } from 'constants/color'

export const Container = styled.div`
    position: relative;
    height: 100%;
    width: 40%;
    ${FlexCentered}
    justify-content: flex-start;
    padding: 0px 10px;
`

export const TabWrapper = styled.div`
    cursor: default;
    height: 100%;
    background-color: ${props =>
        props.$activeColor || artefactColors.focusMode};
    border-radius: 8px 8px 0px 0px;
    ${FlexCentered}
    margin: 0px 5px;
    padding: 0px 5px;

    & > * {
        margin: 0px 6px;
    }

    ${hideWhenNoChildren}
`

export const ButtonWrapper = styled.div`
    position: relative;

    width: 24px;
    height: 100%;
    ${FlexCentered}

    ${({ enabled, $isDisabled }) => {
        let cursor = enabled ? 'default' : 'pointer'
        cursor = $isDisabled ? 'default' : cursor
        return css`
            cursor: ${cursor};
        `
    }};

    ${hideWhenNoChildren}
`

export const ControlTooltip = styled(Tooltip2)`
    height: 100%;
    width: 100%;
    display: flex !important;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${({ $rightControl }) => {
        return !$rightControl && `margin-left: 15px; width: unset;`
    }}
    & > * {
        cursor: pointer;
    }

    ${hideWhenNoChildren}
`

export const Cross = {
    Wrapper: styled.div`
        height: 100%;
        ${FlexCentered}
        cursor: pointer;
    `,
    Icon: styled.img`
        height: 34px;
        width: 34px;
    `,
}
